import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
import { BLOG_POSTS } from "@/data/blogPosts";
import { Link } from "react-router-dom";
export default function BlogPage() {
	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>Blog</Heading>
				<p className="mt-6 text-sm leading-7 text-slate-700 sm:text-base">
					Product updates, practical workflows, and API guides for teams using Text Formatter at scale.
				</p>
			</section>
			<div className="space-y-6">
				{BLOG_POSTS.map((post) => (
					<article key={post.slug} className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
						<p className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
							Published {new Date(post.publishedAt).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
						</p>
						<Heading as="h2" className="mt-3">
							<Link
								to={`/blog/${post.slug}`}
								className="text-inherit hover:underline decoration-current underline-offset-2"
							>
								{post.title}
							</Link>
						</Heading>
						<p className="mt-4 text-sm leading-7 text-slate-700 sm:text-base">{post.excerpt}</p>
						<Link
							to={`/blog/${post.slug}`}
							className="mt-5 inline-flex font-medium underline-link"
						>
							Read article
						</Link>
					</article>
				))}
			</div>
		</RegularPageLayout>
	);
}
